
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

@Component({
	selector: 'save-row-switcher',
	imports: [],
	templateUrl: './save-row-switcher.component.html',
	styleUrl: './save-row-switcher.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class SaveRowSwitcherComponent {
	editMode = input<boolean>(false);
	readonly editButtonType = input<'ICON' | 'SOLID_BUTTON'>('ICON');
	readonly editButtonText = input('');
	readonly saveButtonDisabled = input(false);
	readonly editClick = output<MouseEvent | Event>();
	readonly saveClick = output<MouseEvent | Event>();
	readonly cancelClick = output<MouseEvent | Event>();

	onEditClick(e: MouseEvent | Event) {
		this.editClick.emit(e);
	}

	onSaveClick(e: MouseEvent | Event) {
		this.saveClick.emit(e);
	}

	onCancelClick(e: MouseEvent | Event) {
		this.cancelClick.emit(e);
	}
}
